module.exports = __webpack_public_path__ + "img/2.a5a2280a.png";